import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ProductForm from '../pages/ProductForm';
import '../../../styles/vendeurs/AjouterProduit.css';
import { fetchCategories, fetchTitresByCategorie, ajouterProduit } from '../../../services/vendeurs/produitService';

function AjouterProduit() {
  const [formData, setFormData] = useState({
    categorie_id: '',
    titre_id: '',
    description: '',
    description_detaillee: '',
    price: '',
    stock: '',
    img: null,
    lieu: '',
    unite: 'kg',
    quantite_min: ''
  });

  const vendeur = JSON.parse(localStorage.getItem('vendeurConnecte'));
  const [categories, setCategories] = useState([]);
  const [titresOptions, setTitresOptions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories().then(setCategories);
  }, []);

  const loadTitresByCategorie = async (categorieId) => {
    try {
      const titres = await fetchTitresByCategorie(categorieId);
      setTitresOptions(titres);
    } catch (err) {
      console.error('Erreur chargement titres :', err);
      setTitresOptions([]);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'categorie_id') {
      loadTitresByCategorie(value);
      setFormData(prev => ({ ...prev, categorie_id: value, titre_id: '' }));
    } else {
      setFormData(prev => ({ ...prev, [name]: files ? files[0] : value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Vérifications
    if (Number(formData.price) < 1 || Number(formData.stock) < 1) {
      return alert("⚠️ Le prix et le stock doivent être au moins 1.");
    }

    if (formData.quantite_min && Number(formData.quantite_min) < 1) {
      return alert("⚠️ La quantité minimale doit être au moins 1.");
    }

    const data = new FormData();
    for (let key in formData) {
      if (formData[key] !== null && formData[key] !== undefined) {
        data.append(key, formData[key]);
      }
    }
    data.append('vendeur_id', vendeur.id);

    try {
      await ajouterProduit(data);
      alert('✅ Produit ajouté avec succès !');
      navigate('/vendeur/produits');
    } catch (err) {
      alert("❌ Erreur lors de l'ajout du produit.");
      console.error(err);
    }
  };

  return (
    <div className="ajouter-produit-container">
      <h2>➕ Ajouter un produit</h2>
      <ProductForm
        formData={formData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        categories={categories}
        titresOptions={titresOptions}
      />
      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <button className="btn-retour" onClick={() => navigate('/vendeur/produits')}>
          Retour à mes produits
        </button>
      </div>
    </div>
  );
}

export default AjouterProduit;
